import { API_V1_PATH } from './api.js';
const withApiPrefix = (path) => `${API_V1_PATH}${path}`;
export const MES_API_ROUTES = {
    settings: {
        productionLines: withApiPrefix('/settings/production-lines'),
        productionLineDetail: (id) => withApiPrefix(`/settings/production-lines/${id}`),
        shifts: withApiPrefix('/settings/shifts'),
        shiftDetail: (id) => withApiPrefix(`/settings/shifts/${id}`),
        stats: withApiPrefix('/settings/stats'),
    },
    customers: {
        list: withApiPrefix('/customers'),
        detail: (id) => withApiPrefix(`/customers/${id}`),
        import: withApiPrefix('/customers/import'),
    },
    engineering: {
        processSheets: withApiPrefix('/engineering/process-sheets'),
    },
    users: {
        list: withApiPrefix('/users'),
        detail: (id) => withApiPrefix(`/users/${id}`),
        permissions: withApiPrefix('/users/permissions'),
        permissionModules: withApiPrefix('/users/permissions/modules'),
        permissionActions: withApiPrefix('/users/permissions/actions'),
        permissionDetail: (role) => withApiPrefix(`/users/permissions/${role}`),
        permissionsInit: withApiPrefix('/users/permissions/init'),
    },
    orders: {
        list: withApiPrefix('/orders'),
        detail: (id) => withApiPrefix(`/orders/${id}`),
        import: withApiPrefix('/orders/import'),
    },
    styles: {
        list: withApiPrefix('/styles'),
        detail: (id) => withApiPrefix(`/styles/${id}`),
        part: (partId) => withApiPrefix(`/styles/parts/${partId}`),
        techPack: (styleId) => withApiPrefix(`/styles/${styleId}/tech-pack`),
        configRecipe: (configId) => withApiPrefix(`/styles/configs/${configId}/recipe`),
        configDetail: (configId) => withApiPrefix(`/styles/configs/${configId}`),
        partConfigs: (partId) => withApiPrefix(`/styles/parts/${partId}/configs`),
        attachments: (styleId) => withApiPrefix(`/styles/${styleId}/attachments`),
        attachmentDetail: (styleId, id) => withApiPrefix(`/styles/${styleId}/attachments/${id}`),
    },
    reports: {
        dailyProduction: withApiPrefix('/reports/daily-production'),
        productionValue: withApiPrefix('/reports/production-value'),
        monthlyShipping: withApiPrefix('/reports/monthly-shipping'),
        dailyShipping: withApiPrefix('/reports/daily-shipping'),
        inventory: withApiPrefix('/reports/inventory'),
        inbound: withApiPrefix('/reports/inbound'),
        wip: withApiPrefix('/reports/wip'),
        customerStatement: withApiPrefix('/reports/customer-statement'),
        efficiencyRuns: withApiPrefix('/reports/efficiency-runs'),
        machineHeatmap: withApiPrefix('/reports/machine-heatmap'),
        productionAlerts: withApiPrefix('/reports/production-alerts'),
    },
    shipping: {
        deliveryNotes: withApiPrefix('/shipping/delivery-notes'),
        deliveryNoteDetail: (id) => withApiPrefix(`/shipping/delivery-notes/${id}`),
        deliveryNoteItems: (deliveryNoteId) => withApiPrefix(`/shipping/delivery-notes/${deliveryNoteId}/items`),
        deliveryNoteItemDetail: (deliveryNoteId, itemId) => withApiPrefix(`/shipping/delivery-notes/${deliveryNoteId}/items/${itemId}`),
        deliveryNotePrint: (id) => withApiPrefix(`/shipping/delivery-notes/${id}/print`),
    },
    production: {
        machines: withApiPrefix('/production/machines'),
        machineDetail: (id) => withApiPrefix(`/production/machines/${id}`),
        machineStatus: (id) => withApiPrefix(`/production/machines/${id}/status`),
        bundleBatches: withApiPrefix('/bundles/batches'),
        bundleBatchDetail: (id) => withApiPrefix(`/bundles/batches/${id}`),
        bundles: withApiPrefix('/bundles/list/all'),
        bundleDetail: (id) => withApiPrefix(`/bundles/${id}`),
        bundleSearch: withApiPrefix('/production/bundles/search'),
        importBundles: withApiPrefix('/bundles/import-excel'),
        inventoryStats: withApiPrefix('/bundles/inventory/stats'),
    },
    planning: {
        plans: withApiPrefix('/production-plans'),
        pendingOrders: withApiPrefix('/production-plans/pending-orders'),
        planDetail: (id) => withApiPrefix(`/production-plans/${id}`),
        orderExtra: (orderId) => withApiPrefix(`/production-plans/orders/${orderId}/extra`),
        scheduleGenerate: withApiPrefix('/production-plans/schedule/generate'),
        schedulePlans: withApiPrefix('/production-plans/schedule/plans'),
        schedulePlanDetail: (planId) => withApiPrefix(`/production-plans/schedule/plans/${planId}`),
        publishSchedulePlan: (planId) => withApiPrefix(`/production-plans/schedule/plans/${planId}/publish`),
        scheduleInsertOrder: (planId) => withApiPrefix(`/production-plans/schedule/plans/${planId}/insert`),
        scheduleReschedule: (planId) => withApiPrefix(`/production-plans/schedule/plans/${planId}/reschedule`),
        scheduleItemMove: (itemId) => withApiPrefix(`/production-plans/schedule/items/${itemId}/move`),
        scheduleItemLock: (itemId) => withApiPrefix(`/production-plans/schedule/items/${itemId}/lock`),
        dashboardUtilization: withApiPrefix('/production-plans/dashboard/utilization'),
        dashboardDelays: withApiPrefix('/production-plans/dashboard/delays'),
        dashboardChangeovers: withApiPrefix('/production-plans/dashboard/changeovers'),
    },
    quality: {
        testReports: withApiPrefix('/quality/test-reports'),
        testReportDetail: (id) => withApiPrefix(`/quality/test-reports/${id}`),
        testReportItems: (reportId) => withApiPrefix(`/quality/test-reports/${reportId}/items`),
        testReportComplete: (id) => withApiPrefix(`/quality/test-reports/${id}/complete`),
        testReportUploadPdf: (id) => withApiPrefix(`/quality/test-reports/${id}/upload-pdf`),
        testItemDetail: (id) => withApiPrefix(`/quality/test-items/${id}`),
        techReports: withApiPrefix('/quality/tech-reports'),
        techReportDetail: (id) => withApiPrefix(`/quality/tech-reports/${id}`),
        techReportSubmit: (id) => withApiPrefix(`/quality/tech-reports/${id}/submit`),
        techReportApprovePm: (id) => withApiPrefix(`/quality/tech-reports/${id}/approve-pm`),
        techReportApproveDirector: (id) => withApiPrefix(`/quality/tech-reports/${id}/approve-director`),
        techReportReject: (id) => withApiPrefix(`/quality/tech-reports/${id}/reject`),
    },
    scans: {
        stations: withApiPrefix('/scans/stations'),
        lines: withApiPrefix('/scans/lines'),
        create: withApiPrefix('/scans'),
        recent: (limit) => withApiPrefix(`/scans/recent?limit=${limit}`),
    },
    customerTracking: {
        profile: withApiPrefix('/customer-tracking/profile'),
        pos: withApiPrefix('/customer-tracking/pos'),
        poDetail: (id) => withApiPrefix(`/customer-tracking/pos/${id}`),
        poSchedule: (id) => withApiPrefix(`/customer-tracking/pos/${id}/schedule`),
        poQc: (id) => withApiPrefix(`/customer-tracking/pos/${id}/qc`),
        poShipments: (id) => withApiPrefix(`/customer-tracking/pos/${id}/shipments`),
    },
};
export const MES_INTEGRATION_ROUTES = {
    customers: MES_API_ROUTES.customers.list.replace('/customers', '/integration/customers'),
    customerDetail: (id) => withApiPrefix(`/integration/customers/${id}`),
    orders: withApiPrefix('/integration/orders'),
    orderDetail: (id) => withApiPrefix(`/integration/orders/${id}`),
    orderProgress: (id) => withApiPrefix(`/integration/orders/${id}/progress`),
    quotations: withApiPrefix('/integration/quotations'),
    quotationByStyle: (styleId) => withApiPrefix(`/integration/quotations/style/${styleId}`),
    productionLines: withApiPrefix('/integration/production-lines'),
    productionLineStats: withApiPrefix('/integration/production-lines/stats'),
    productionLineRevenue: withApiPrefix('/integration/production-lines/revenue'),
    styles: withApiPrefix('/integration/styles'),
    styleDetail: (id) => withApiPrefix(`/integration/styles/${id}`),
    syncChanges: withApiPrefix('/integration/sync/changes'),
    syncOrders: withApiPrefix('/integration/orders/sync'),
    customerStatement: withApiPrefix('/integration/reports/customer-statement'),
};
export const MES_USER_SYNC_ROUTES = {
    create: withApiPrefix('/users/sync'),
    password: withApiPrefix('/users/sync/password'),
    delete: (username) => withApiPrefix(`/users/sync/${username}`),
};
export const ERP_AUTH_API_ROUTES = {
    login: '/auth/login',
    register: '/auth/register',
    changePassword: '/users/change-password',
};
